import HttpClient from "../../../../../utils/httpClient";

const removeSpecialCharacters = (inputString) => {
  // Define a regular expression pattern that matches any non-alphanumeric character excluding spaces
  var pattern = /[^a-zA-Z0-9\s]/g;

  // Use the replace() method to replace all occurrences of the pattern with an empty string
  var resultString = inputString.replace(pattern, "");

  return resultString;
};

/**
 * Submits the /internal form: creates the account/restaurant/site rows in the DB and
 * notifies Slack (server/services/restogpt.js -> handleInternalRestogptRegistration).
 * Does not scrape or auto-populate a menu — the menu row is created empty.
 */
const submitData = async (
  formInternalData,
  siteName,
  decodedValue,
  apiPath = "internal-restogpt"
) => {
  const resName = removeSpecialCharacters(formInternalData.restaurantName);

  let hearAboutValue = "";
  if (formInternalData.hearAbout === "Referral") {
    hearAboutValue = formInternalData.hearAboutReferrer;
  } else if (formInternalData.hearAbout === "Other") {
    hearAboutValue = formInternalData.hearAboutOther;
  } else {
    hearAboutValue = formInternalData.hearAbout;
  }

  const data = {
    restaurant_name: formInternalData.restaurantName.replace("'", ""),
    restaurant_type: formInternalData.restaurantType,
    website: formInternalData.companyWebsite || "",
    menu: formInternalData.restaurantWebsite,
    address: formInternalData.restaurantAddress,
    color: formInternalData.color,
    logo: formInternalData.logo || "",
    customer_name: formInternalData.customerName || "",
    email: formInternalData.email,
    phone: "+1" + (formInternalData.phone || ""),
    domain_name: resName.replace(/\s+/g, "-").toLowerCase(),
    hear_about: hearAboutValue,
    pizzabox: false,
    lati: formInternalData.latitude,
    longi: formInternalData.longitude,
  };

  return HttpClient.requestData(apiPath, "POST", data);
};

export default submitData;
